import { JsCustomBehaviors, JsInitializer, JsMessageHandlers, } from "../../";
import { EvalError, fetchDatasetContent, getBehaviorFn, getInitFn, } from ".";
import { builtInMessageHandlers } from "./messagehandler";
export async function simulationFromRequest(manifestSrc, datasetCache, pyodideEnabled) {
    const manifest = parseAndThrowProper(manifestSrc, "manifest.json");
    const properties = parseAndThrowProper(manifest.propertiesSrc, "globals.json");
    const datasets = await fetchDatasetContent(manifest.datasets, datasetCache);
    const handlers = builtInMessageHandlers;
    if (manifest.initializers.length !== 1) {
        throw new Error(`Only one initializer is supported, but the following were supplied: ${manifest.initializers}`);
    }
    const initFile = manifest.initializers.pop();
    const initFn = await getInitFn(initFile.name, initFile.initSrc);
    const behaviors = [];
    for (const behavior of manifest.behaviors) {
        if (behavior.shortname.endsWith(".py") && !pyodideEnabled) {
            throw new Error("Cannot load pyodide");
        }
        behaviors.push({
            behavior: await getBehaviorFn(behavior.shortname, behavior.behaviorSrc),
            dependencies: behavior.dependencies ?? [],
            name: behavior.shortname,
        });
    }
    return {
        properties: properties,
        initializer: new JsInitializer(initFile.name, initFn, properties, datasets),
        datasets: datasets,
        behaviors: new JsCustomBehaviors(behaviors, properties, datasets),
        handlers: new JsMessageHandlers(handlers),
    };
}
export function parseAndThrowProper(item, context) {
    try {
        return item !== "" ? JSON.parse(item) : {};
    }
    catch (e) {
        throw new EvalError(e, context);
    }
}
//# sourceMappingURL=simFromSrc.js.map